/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsAddMember } from "../../funcs/authTeamsAddMember.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.AddTeamMemberRequest$inboundSchema,
};

export const tool$authTeamsAddMember: ToolDefinition<typeof args> = {
  name: "auth-teams-add-member",
  description: `Add a team member

Attach a principal (user or service account) to the team by its userId.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsAddMember(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
